import Rete from "rete";
import { ResetSocket, ResetControl } from "../../rete-controls/ResetControl.js";

export default class ResetComponent extends Rete.Component {
  constructor() {
    super("Reset"); // name
    this._categories = ["Simulator"];
    this._lastTriggerTime = 1000;
    this.sleepTimeMs = 1000;
  }

  builder(node) {
    var out1 = new Rete.Output("out1", "OP", ResetSocket);
    var opControl = new ResetControl(this.editor, "reset", this.sleepTimeMs);

    return node.addOutput(out1).addControl(opControl);
  }

  worker(node, inputs, outputs) {
    var newTime = node.data.reset;
    var nowMs = new Date();
    nowMs = nowMs.getTime();
    var difference_ms = 0;
    if (newTime == undefined || newTime == null) return;
    if (this._lastTriggerTime == newTime) return;
    if (this._lastTriggerTime == null || this._lastTriggerTime == undefined) {
      this._lastTriggerTime = newTime;
    } else {
      if (!Number.isSafeInteger(this._lastTriggerTime)) {
        this._lastTriggerTime = new Date(this._lastTriggerTime).getTime();
      }
      difference_ms = nowMs - this._lastTriggerTime;
    }

    if (difference_ms > this.sleepTimeMs) {

      outputs["out1"] = newTime;
      this._lastTriggerTime = newTime;
    }
  }
}
